import React from "react";
import { Tabs } from "@ann/web-components";
import { TabsContainer } from "./Tabs.styled";
import { UserDetailsTabsEnum } from "../../enums/userDetailsTabs";

const UserDetailsTabs = ({ onTabChange, defaultIndex = UserDetailsTabsEnum.OVERVIEW }) => {
  const handleTabChange = (index) => {
    if (onTabChange) {
      onTabChange(index);
    }
  };

  return (
    <TabsContainer>
      <Tabs defaultIndex={defaultIndex} size="medium" onChange={handleTabChange}>
        <Tabs.List>
          <Tabs.Tab iconLeft="person" index={UserDetailsTabsEnum.OVERVIEW}>
            Overview
          </Tabs.Tab>
          <Tabs.Tab iconLeft="lockOpen" index={UserDetailsTabsEnum.ROLES_AND_PERMISSIONS}>
            Roles & Permissions
          </Tabs.Tab>
          <Tabs.Tab iconLeft="group" index={UserDetailsTabsEnum.GROUPS}>
            Groups
          </Tabs.Tab>
          <Tabs.Tab iconLeft="lastUpdated" index={UserDetailsTabsEnum.ACTIVITY_HISTORY}>
            Activity History
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>
    </TabsContainer>
  );
};

export default UserDetailsTabs;

